import { Button, Divider, Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import Link from '/@/components/link';
import { isExpertoBayer } from '/@/core/settings';
import { _ } from '/@/locale';
import { getSelectedFeature } from '/@/store/nav/selectors';
import type { Field } from '/@/types/field';
import useIsMobile from '/@/utils/hooks/is-mobile';

const SidebarActions = ({
    activeView,
    userTypeView,
    showFrostRiskMap,
    showMaps,
    showActions,
    showWeeds,
    handleGoToNewField,
    fields,
    handleViewMap,
    handleViewList,
}: {
    activeView: 'list' | 'map';
    userTypeView: 'user' | 'rv';
    showFrostRiskMap: boolean;
    showMaps: boolean;
    showActions: boolean;
    showWeeds: boolean;
    handleGoToNewField: ({ view, selectedFeature }: { view: string; selectedFeature: string }) => void;
    fields: Field[];
    handleViewMap: () => void;
    handleViewList: () => void;
}) => {
    const selectedFeature = useSelector(getSelectedFeature);
    const isListView = activeView === 'list';
    const isMobile = useIsMobile();
    if (selectedFeature.selectedFeature === 'nitrogen' && !isMobile) return;
    return (
        <Stack spacing={1}>
            {selectedFeature.selectedFeature === 'recommendation' && <Divider sx={{ mb: 2 }} />}
            {userTypeView === 'user' && isMobile && !isListView && !showFrostRiskMap && !showMaps && (
                <Button
                    fullWidth
                    variant='contained'
                    color='secondary'
                    onClick={() =>
                        handleGoToNewField({
                            view: 'fields.NewField',
                            selectedFeature: 'FieldDetail',
                        })
                    }
                >
                    {_('Agregar lote')}
                </Button>
            )}
            {fields.length > 0 && !isExpertoBayer() && isMobile && (
                <Button
                    fullWidth
                    variant={isListView ? (showActions || showWeeds ? 'outlined' : 'contained') : 'outlined'}
                    color='secondary'
                    onClick={isListView ? handleViewMap : handleViewList}
                >
                    {isListView
                        ? showActions || showWeeds
                            ? _('Ver Lote en el mapa')
                            : _('Seleccionar en el Mapa')
                        : showActions
                          ? _('Volver al Lote')
                          : _('Mis Lotes')}
                </Button>
            )}
            {selectedFeature.selectedFeature === 'recommendation' && (
                <Link to='MyRecommendations'>
                    <Button fullWidth color='secondary' variant='outlined'>
                        {_('Mis Recomendaciones')}
                    </Button>
                </Link>
            )}
        </Stack>
    );
};

export default SidebarActions;
